export const FETCH_COURSE_REQUEST = 'courses/course/FETCH_REQUEST';
export const FETCH_COURSE_SUCCESS = 'courses/course/FETCH_SUCCESS';
export const FETCH_COURSE_FAILURE = 'courses/course/FETCH_FAILURE';
export const FETCH_COURSES_REQUEST = 'courses/FETCH_REQUEST';
export const FETCH_COURSES_SUCCESS = 'courses/FETCH_SUCCESS';
export const FETCH_COURSES_FAILURE = 'courses/FETCH_FAILURE';
export const NEXT_COURSES_PAGE = 'courses/NEXT_PAGE';

export const RESET = 'courses/RESET';


// WEBPACK FOOTER //
// ./src/modules/courses/actionTypes.js